import { CHART_COLORS } from "./utils";

export { CHART_COLORS };



// WEBPACK FOOTER //
// ./client/modules/core/Chart/common/index.ts